<app-page-modifications>
    <app-header class="full-width"></app-header>
    <main id="content" class="js-content" role="main">
        <div class="grid-row">
            <div [class]="shouldShowMore ? 'column-two-thirds' : 'column-full'">
                <header class="page-header">
                    <h1 class="aa-title-size" tabindex="0">{{ modeText }} check</h1>
                    <br>
                    <h2 class="aa-lead-size" tabindex="0">What to expect</h2>
                </header>

                <div>
                    <ul class="text list list-bullet aa-copy-size" tabindex="0">
                    <li>There will be <strong>3 practice questions</strong>.</li>
                    <li>Then there will be <strong>{{count}} questions</strong>.</li>
                    <li>Each question will show for <strong>{{questionTime}} seconds</strong>.</li>
                    </ul>

                    <div>
                        <p>
                            <button class="button aa-button-size aa-contrast-button" (click)="onClick()" role="button" id="start-now-button">
                            Next
                            </button>
                        </p>
                    </div>
                </div>
            </div>
            <div *ngIf="shouldShowMore" class="column-one-third more-links aa-copy-size">
                <strong class='aa-contrast-border' speak="true" tabindex="0">More</strong>
                <ul>
                    <li><a routerLink="/access-settings" tabindex="0">Edit your settings</a></li>
                </ul>
            </div>
        </div>
    </main>
</app-page-modifications>
